module.exports = "<!-- component html goes here -->\r\n <ng2-toasty [position]=\"'center-center'\"></ng2-toasty>\r\n "